import Button from "@components/common/Button.component";
import { GANGSTABET_PRODUCT } from "@constants/images";

const GangstabetInfo = () => {
  return (
    <>
      <div className="gsp-info-wrapper">
        <h4 className="gsp-info-heading">Gangsters and Detectives</h4>
        <p className="gsp-info-text">
          GangstaBets are created as ICON’s Non-Fungible Token (NFT) standard,
          IRC-3 (similar to Ethereum’s ERC721). Each character is an animated
          GIF, and stored in IPFS. All the characters will be generated
          programmatically with varying teams, classes and appearances.
          Characters will either become gangsters or detectives. Within each
          group, there will be a variety of classes with a specific skill.
        </p>

        {/* <br /> */}

        {/* <p className="gsp-info-text">
          GangstaBet is a collection of 5555 unique digital collectibles where owner can evolve their character (name, skill, story) by burning  GangstaBetToken ($GBET) that is distributed to its holder on a daily basis.
          The supply of the tokens will decrease periodically through a halving, and the distribution will stop after exactly 9 years.
        </p> */}

        <Button
          onClick={() =>
            window.open(
              "https://medium.com/@gangstabet/gangstabet-a-digital-collectible-project-12e981c77bee"
            )
          }
        >
          Learn More
        </Button>
      </div>
      {/* <img
        className="gsp-banner"
        src={GANGSTABET_PRODUCT.BANNER}
        alt="banner"
      /> */}
    </>
  );
};
export default GangstabetInfo;
